import React from 'react'
import { string, bool } from 'prop-types'
import { Icon, Color, H3, Chip, Media } from '@cobalt/cobalt-react-components'
import { MFA_SETTINGS_ACTIVE } from '../../constants/ui.labels'

const MechanismOption = ({
  icon,
  name,
  description,
  isActive,
  activeColor,
  defaultColor
}) => (
  <Media alignVerticalCenter>
    <Icon name={icon} medium color={isActive ? activeColor : defaultColor} />
    <H3 asH5>
      {name}
      {isActive && (
        <Chip success alternate small>
          {MFA_SETTINGS_ACTIVE}
        </Chip>
      )}
    </H3>
    <em>{description}</em>
  </Media>
)

MechanismOption.propTypes = {
  icon: string.isRequired,
  name: string.isRequired,
  description: string.isRequired,
  isActive: bool.isRequired,
  activeColor: string,
  defaultColor: string
}

MechanismOption.defaultProps = {
  defaultColor: Color.gray[500]
}

export default MechanismOption
